"use strict";

/* původní znění: 
window.tResponsive = function (mainElement, options) {
        this.mainElem = $(mainElement);
        this.content = $(this.mainElem.children().get(0));
        this.options = $.extend({
        }, options);
    };
    
*/

export class tResponsive {

/*    constructor: ed.widgets.tResponsive, chm? takovej widget nikde neexistuje, tak nevim, co to má znamenat :) */ 

    constructor (mainElement, options) {
        this.mainElem = $(mainElement);
        this.content = $(this.mainElem.children().get(0));
        this.options = $.extend({}, options);  
    }

    init () {
        this.mainElem.wrap('<div class="table-responsive-box"></div>');
        this.box = this.mainElem.closest('.table-responsive-box');

        this.box.prepend('<div class="table-responsive-pointer table-responsive-left"></div>');
        this.box.prepend('<div class="table-responsive-pointer table-responsive-right"></div>');
        this.left = $('.table-responsive-left', this.box);
        this.right = $('.table-responsive-right', this.box);
        this.mainElem.on("cev_tResponsiveCheck", this._handleScroll.bind(this));
        // this.mainElem.on("scroll", this._handleScroll.bind(this));
        this.mainElem.on("scroll", this._triggerCheck.bind(this));
        // $(window).on("resize", this._triggerCheck.bind(this));
    }
    
    _triggerCheck () {
        this.mainElem.trigger('cev_tResponsiveCheck');
    }
    
    _handleScroll (e) {
        this._checkWidth();
        this.checkLeftRight();
    }
    
    _checkLeft () {
        if(this.mainElem.scrollLeft()){
            this.left.removeClass("hidden");
        }else{
            this.left.addClass("hidden");
        }
    } 
    
    _checkRight () {

        var displayWidth= this.mainElem.width();
        if(this.mainElem.is(':visible')) {
            var scrollWidth = this.mainElem.get(0).scrollWidth;
            //console.log(scrollWidth, " - ", this.mainElem.scrollLeft() , " - ",displayWidth, " = ",scrollWidth - this.mainElem.scrollLeft() - displayWidth);
            if(Math.abs(scrollWidth - this.mainElem.scrollLeft() - displayWidth) > 4 ){
                this.right.removeClass("hidden");
            }else{
                this.right.addClass("hidden");
            }
        }else{
            this.right.addClass("hidden");
        }
    }
    
    _checkWidth () {
        this.box.width("");
        var width = this.mainElem.width();
        this.box.width(width , this.mainElem);
      // console.log("MainElem: ", this.mainElem.width(), this.mainElem.get(0).scrollWidth, this.mainElem);
      // console.log("Box:", this.box.width(), this.box);

    }

    checkLeftRight () {
        this._checkLeft();
        this._checkRight();
    }
};